import { shouldAnimate, transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import { headingStyles } from '@helpers/typography';
import TabButton from '@stories/Components/Buttons/TabButton/TabButton';
import TabButtonStyles from '@stories/Components/Buttons/TabButton/TabButton.styles';
import styled, { css } from 'styled-components';
const Container = styled.div `
  ${transition('opacity')};
  border-top: 2px solid ${brand.lightGrey};
  padding-top: 15px;

  @media ${from(Device.TabletLarge)} {
    padding-top: 30px;
  }
`;
const Grid = styled.div `
  ${scrollbars};

  display: flex;
  gap: 5px;
  flex-wrap: nowrap;
  overflow: auto;


  ${TabButtonStyles.Container} {
    white-space: nowrap;

    &[data-theme='light'] {
      --colorBg: transparent;
      --colorBorderActive: ${brand.yellow};
    }
  }

  ${shouldAnimate(css `
    transition-delay: 0.15s;

    [data-animate='false'] & {
      opacity: 0;
    }

    [data-animate='true'] & {
      opacity: 1;
    }
  `)}
`;
const Title = styled.h2 `
  ${headingStyles}
  font-size: 20px;
`;
const Tab = styled(TabButton) `
    height: 45px;
    border-radius: 30px;
    min-width: 60px;

    &[aria-current='true'] {
       --colorBorderActive: ${brand.yellow};
    }
`;
const BedroomTabStyles = {
    Container,
    Title,
    Tab,
    Grid,
};
export default BedroomTabStyles;
